(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["beats-grid"] && !Shopify.designMode) return;
  try {
    
(function () {
  var STORAGE_KEY = 'beatsPlayerState';
  var PREVIEW_SECONDS = 30;
  var audio = null;
  var observer = null;
  var observedCard = null;

  function readState() {
    try { return JSON.parse(sessionStorage.getItem(STORAGE_KEY)); } catch (e) { return null; }
  }
  function writeState(state) { sessionStorage.setItem(STORAGE_KEY, JSON.stringify(state)); }
  function clearState() { sessionStorage.removeItem(STORAGE_KEY); }

  function getMiniEls() {
    return {
      player: document.querySelector('[data-mini-player]'),
      cover: document.querySelector('[data-mini-cover]'),
      name: document.querySelector('[data-mini-name]'),
      progress: document.querySelector('[data-mini-progress]'),
      toggle: document.querySelector('[data-mini-toggle]'),
      iconPlay: document.querySelector('[data-mini-icon-play]'),
      iconPause: document.querySelector('[data-mini-icon-pause]'),
      buy: document.querySelector('[data-mini-buy]')
    };
  }

  function showMini(state) {
    var els = getMiniEls();
    if (!els.player) return;
    els.cover.src = state.image || '';
    els.name.textContent = state.title + ' — preview';
    els.buy.href = state.url;
    els.player.hidden = false;
    requestAnimationFrame(function () { els.player.classList.add('is-visible'); });
    updatePauseIcon(state.paused);
  }

  function hideMini() {
    var els = getMiniEls();
    if (!els.player) return;
    els.player.classList.remove('is-visible');
  }

  function updatePauseIcon(paused) {
    var els = getMiniEls();
    if (!els.iconPlay) return;
    els.iconPlay.hidden = !paused;
    els.iconPause.hidden = paused;
  }

  function updateCardIcon(productId, active) {
    document.querySelectorAll('[data-beat-card]').forEach(function (card) {
      var overlay = card.querySelector('[data-beat-overlay]');
      if (!overlay) return;
      overlay.classList.toggle('is-active', active && card.dataset.productId === productId);
    });
  }

  function stopPreview() {
    if (audio) { audio.pause(); }
    clearState();
    hideMini();
    updateCardIcon(null, false);
    if (observer) { observer.disconnect(); observer = null; }
  }

  function startPreview(card) {
    var src = card.dataset.previewSrc;
    if (!src) return;
    var productId = card.dataset.productId;
    if (!audio) { audio = new Audio(); }
    audio.src = src;
    audio.currentTime = 0;
    audio.play();

    var state = {
      productId: productId,
      title: card.dataset.title,
      price: card.dataset.price,
      image: card.dataset.image,
      url: card.dataset.url,
      src: src,
      paused: false
    };
    writeState(state);
    updateCardIcon(productId, true);
    showMini(state);
    watchCard(card);

    audio.ontimeupdate = function () {
      var pct = Math.min(100, (audio.currentTime / PREVIEW_SECONDS) * 100);
      var els = getMiniEls();
      if (els.progress) els.progress.style.width = pct + '%';
      if (audio.currentTime >= PREVIEW_SECONDS) stopPreview();
    };
  }

  function togglePause() {
    if (!audio) return;
    var state = readState();
    if (!state) return;
    if (audio.paused) { audio.play(); state.paused = false; }
    else { audio.pause(); state.paused = true; }
    writeState(state);
    updatePauseIcon(state.paused);
    updateCardIcon(state.productId, !state.paused);
  }

  function watchCard(card) {
    if (observer) observer.disconnect();
    observedCard = card;
    observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) hideMini(); else showMiniIfState();
      });
    }, { threshold: 0.2 });
    observer.observe(card);
  }

  function showMiniIfState() {
    var state = readState();
    if (state) showMini(state);
  }

  function resumeFromStorage() {
    var state = readState();
    if (!state) return;
    if (!audio) { audio = new Audio(); }
    audio.src = state.src;
    if (!state.paused) { audio.play(); }
    audio.ontimeupdate = function () {
      var pct = Math.min(100, (audio.currentTime / PREVIEW_SECONDS) * 100);
      var els = getMiniEls();
      if (els.progress) els.progress.style.width = pct + '%';
      if (audio.currentTime >= PREVIEW_SECONDS) stopPreview();
    };
    updateCardIcon(state.productId, !state.paused);

    var matchingCard = document.querySelector('[data-beat-card][data-product-id="' + state.productId + '"]');
    if (matchingCard) {
      watchCard(matchingCard);
      showMiniIfState();
    } else {
      showMini(state);
    }
  }

  document.addEventListener('click', function (e) {
    var playBtn = e.target.closest('[data-beat-play]');
    if (playBtn) {
      e.preventDefault();
      e.stopPropagation();
      var card = playBtn.closest('[data-beat-card]');
      var state = readState();
      if (state && state.productId === card.dataset.productId) togglePause();
      else startPreview(card);
      return;
    }
    var openTarget = e.target.closest('[data-beat-open]');
    if (openTarget) {
      var openCard = openTarget.closest('[data-beat-card]');
      if (openCard && openCard.dataset.url) window.location.href = openCard.dataset.url;
    }
  });

  var miniToggle = document.querySelector('[data-mini-toggle]');
  if (miniToggle) miniToggle.addEventListener('click', togglePause);

  resumeFromStorage();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
